import { scrollToElement } from "@/components/global/scroll-to-element";

export default function ScrollToBlock() {
  const wrapper = document.querySelectorAll<HTMLDivElement>(".js-scroll-to-block");
  const floatingContentBlock = document.querySelectorAll<HTMLDivElement>(".js-floating-content[data-banner=true]");

  if (wrapper) {
    wrapper.forEach((item) => {
      const scrollToBtns = item.querySelectorAll<HTMLButtonElement>(".js-scroll-to-btn");
      const contentWrapper = document.querySelector<HTMLDivElement>(".js-progress-wrapper");
      const progressBar = item.querySelector<HTMLDivElement>(".js-progress-bar");

      const handleStickyTop = () => {
        requestAnimationFrame(() => {
          const header = document.querySelector("header");
          const headerHeight = header ? header.offsetHeight : 0;

          item.style.top = `${headerHeight}px`;
        });
      };

      const handleScrollTo = (id: string) => {
        if (id) {
          scrollToElement(id, { smooth: true, gap: 58 });
        }
      };

      const handleScrollProgress = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollBottom = scrollTop + document.documentElement.clientHeight;
        const stickyHeaderHeight = document.querySelector("header")?.offsetHeight || 0;
        const contentOffset = contentWrapper?.offsetTop || 0;
        const contentHeight = contentWrapper?.offsetHeight || 0;
        const startOffset = contentOffset - stickyHeaderHeight;
        const endOffset = contentOffset + contentHeight;
        let scrolled = 0;

        if (progressBar) {
          if (scrollTop <= startOffset) {
            progressBar.style.width = "0%";
          } else if (scrollBottom >= endOffset) {
            progressBar.style.width = "100%";
          } else {
            scrolled = ((scrollTop - startOffset) / (contentHeight + stickyHeaderHeight - document.documentElement.clientHeight)) * 100;
            progressBar.style.width = Math.min(scrolled, 100) + "%";
          }
        }
      };

      const handleSectionOffset = () => {
        const stickyHeaderHeight = document.querySelector("header")?.offsetHeight || 0;
        const stickyScrollToNavHeight = item.offsetHeight || 0;

        return stickyHeaderHeight + stickyScrollToNavHeight;
      };

      const handleActiveIntoView = () => {
        const menuWrapper = item.querySelector(".js-menu-wrapper");
        const activeItem = menuWrapper?.querySelector('[data-active="true"]');

        if (menuWrapper && activeItem) {
          const menuRect = menuWrapper.getBoundingClientRect();
          const activeRect = activeItem.getBoundingClientRect();
          const containerPadding = 26;

          const overflowLeft = activeRect.left < menuRect.left;
          const overflowRight = activeRect.right > menuRect.right;

          if (overflowLeft) {
            menuWrapper.scrollBy({ left: activeRect.left - menuRect.left - containerPadding, behavior: "smooth" });
          }

          if (overflowRight) {
            menuWrapper.scrollBy({ left: activeRect.right - menuRect.right + containerPadding, behavior: "smooth" });
          }
        }
      };

      const handleActiveSection = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let startOffset = 0;

        if (scrollToBtns && scrollToBtns.length > 0) {
          scrollToBtns.forEach((btn, index) => {
            const scrollId = btn.getAttribute("data-id");
            if (scrollId) {
              const section = document.getElementById(scrollId);

              if (section) {
                const sectionTopOffset = section.offsetTop - handleSectionOffset() - 5; // trigger 5 pixels early
                const sectionBottomOffset = section.offsetTop + section.offsetHeight - handleSectionOffset() - 5; // add 5 pixel buffer

                // define above the fold amount based on the top of the first item
                if (index === 0) {
                  startOffset = sectionTopOffset;
                }

                // set each section to active if you're in view of the section
                // else set first item active if scroll top is above the fold
                if (scrollTop >= sectionTopOffset && scrollTop < sectionBottomOffset) {
                  btn.setAttribute("data-active", "true");
                } else if (scrollTop < startOffset && index === 0) {
                  btn.setAttribute("data-active", "true");
                } else {
                  btn.setAttribute("data-active", "false");
                }
              }
            }
          });

          handleActiveIntoView();
        }
      };

      if (scrollToBtns && scrollToBtns.length > 0) {
        handleActiveSection();
        window.addEventListener("scroll", handleActiveSection);

        scrollToBtns.forEach((btn) => {
          const scrollId = btn.getAttribute("data-id");
          if (scrollId) {
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              handleScrollTo(scrollId);
            });
          }
        });
      }

      if (progressBar) {
        window.addEventListener("scroll", handleScrollProgress);
      }

      const debounce = (func: () => void, delay: number) => {
        let timeout: any;
        return function () {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            func();
          }, delay);
        };
      };

      handleStickyTop();
      window.addEventListener("resize", debounce(handleStickyTop, 100));

      // if there is floating content then adjust the top position on close
      if (floatingContentBlock && floatingContentBlock.length > 0) {
        floatingContentBlock.forEach((item) => {
          const closeBtn = item.querySelector(".js-close-btn");
          // adjust top nav bar position when floating content closes
          closeBtn?.addEventListener("click", handleStickyTop);
        });
      }
    });
  }
}
